const $ = require('jquery');
const forEach = require('lodash.foreach');

const name = getQueryVariable('name');
// const email = getQueryVariable('email');

if (name) {
  $('#name').text(`, ${name}`);
} else {
  $('#name').remove();
}

if ($('.js-redirect').length) {
  populateRedirectButton();
}

function getQueryVariable(variable) {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i += 1) {
    const pair = vars[i].split('=');
    if (pair[0] === variable) {
      return decodeURIComponent(pair[1]);
    }
  }
  return false;
}

// swap standard error messages for custom ones
// clientside validation doesn't use the custom messages,
// so we update the default message data attribute to the
// custom one
const $fields = $('[data-webform-required-error]');

forEach($fields, item => {
  const realErrorMsg = item.dataset.webformRequiredError;
  item.dataset.msgRequired = realErrorMsg;
});

// add in * for required fields since webform doesn't like to add them
const $allInputs = $('[required], [required="true"]');

forEach($allInputs, item => {
  if ($(item).is('input') || $(item).is('select')) {
    $(item).siblings('label').not('.error').append('<span class="required-mark">*</span>');
  }

  if ($(item).is('textarea')) {
    $(item).parent().siblings('label').not('.error').append('<span class="required-mark">*</span>');
  }
});

// add * to file fields. Drupal handles them differently than rest of fields so need custom code
const $fileInputWrappers = $('.form-managed-file.required');

forEach($fileInputWrappers, item => {
  $(item).siblings('label').not('.error').append('<span class="required-mark">*</span>');
});

function populateRedirectButton() {
  const url = getQueryVariable('redirect');
  $('.js-redirect').attr('href', url);
}

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

const $addToCartForm = $('.commerce-order-item-add-to-cart-form')
// add validation for add to cart forms
$(document).ready(() => {
  if ($addToCartForm.length) {
    const validator = $addToCartForm.validate();
    // validator.resetForm();
  }
});
